// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__yc10E","spin":"Loader_spin__RTA6g","sm":"Loader_sm__dH3MG","md":"Loader_md__4m6gG","lg":"Loader_lg__gFyKt"};